import { ContextTableData } from 'Context'
import {useContext} from 'react'
import { TypeContextTableData, TypeEntityRow } from 'Type'

const HookModuleTableDataContextRow = (rowIndex :number) :TypeEntityRow | undefined => {
    const context :TypeContextTableData = useContext(ContextTableData)
    return context.data[rowIndex]
}

export default HookModuleTableDataContextRow